// extracted by mini-css-extract-plugin
export default {"block":"reset-password_block__qHG3G","title":"reset-password_title__meMu3","form":"reset-password_form__3iwN5","link":"reset-password_link__5Q7a-"};